// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"70dacfb0","127":"5ed70935","283":"27abec9a","310":"7eef71c8","412":"0db7b438","453":"837ee03f","485":"18787265","626":"298a790a","674":"789452a3","739":"ef4b68bd","815":"8fef209c"}[chunkId] + ".chunk.js";
};